import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';
import { CountResponse, TakeSkipFilter } from '@typings';

import { SegmentsDto } from 'src/models/Segments.model';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

export async function getSegmentsWithCounts(
  params?: TakeSkipFilter
): Promise<CountResponse<SegmentsDto>> {
  let where = {};
  if (!!params?.filter && !!Object.keys(params.filter).length) {
    Object.keys(params.filter).forEach(key => {
      if (params?.filter?.[key]) {
        where = {
          ...where,
          [key]: params.filter[key],
        };
      }
    });
  }

  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/segments/with-entities-count`,
    method: 'GET',
    params: {
      where: JSON.stringify(where),
      returnCount: true,
      take: params?.take || 10,
      skip: params?.skip || 0,
    },
  });

  if (!data) {
    throw Error(data.message);
  }

  return data;
}
